module.exports = __webpack_public_path__ + "static/media/schedule.254dc0cd.svg";